<template>
  <div>
    <div id="container"></div>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import axios from 'axios'; // 引入axios
const http = axios.create({
  baseURL: 'https://restapi.amap.com/v3/',
  timeout: 50000,
})
export default {
  name: "map-view",
  props: {
    mapInfoList: Array,
  },
  watch: {
    mapInfoList(val) {
      this.infoList = val
      if (this.map) {
        this.map.clearMap()
        this.MarkerCluster.setData(null)
        this.MarkerCluster.setMap(null)
        this.updateMapMarker()
      }

      // https://restapi.amap.com/v3/geocode/geo?address=%E9%BB%91%E9%BE%99%E6%B1%9F%E7%9C%81&key=c2718aadc9323a3d982069d21e272954

      // let data = {
      //   address: '黑龙江省',
      //   key: 'c2718aadc9323a3d982069d21e272954',
      // }
      // this.amapRequest('geocode/geo', data).then(res => {
      //   console.log(res)
      //   console.log("=======then===========")
      // })
    },
  },
  data() {
    return {
      map: null,
      MarkerCluster: null,
      infoList: [],
    }
  },
  mounted() {
    this.initAMap()
  },
  unmounted() {
    // this.map?.destroy();
  },
  methods: {
    initAMap() {
      let that = this
      AMapLoader.load({
        key: "ed9c1fcdea839864fb60babb08855a6d", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        that.map = new AMap.Map("container", {
          mapStyle: "amap://styles/fresh",
          center: [125, 42],
          zoom: 4.4
        });
        // 数据中需包含经纬度信息字段(记得权重weight改成number类型)
        that.updateMapMarker()
      })
    },
    updateMapMarker() {
      let that = this

      //构建信息窗体
      let infoWindow = new AMap.InfoWindow({
        isCustom: true,
        anchor: 'left-center',
        offset: new AMap.Pixel(30, -10),
        content: ''
      });

      var _renderClusterMarker = function (context) {
        let div = "<div class=\"circleBox\">\n" +
            "      <div class=\"circle\"></div>\n" +
            "      <div class=\"circle1\"></div>\n" +
            "      <div class=\"circle2\"></div>\n" +
            "      <div class=\"circle3\"></div>\n" +
            "    </div>"
        context.marker.setContent(div)

        // 自定义点击事件
        context.marker.on('click', function (e) {
          var curZoom = that.map.getZoom();
          if (curZoom < 20) {
            curZoom += 4;
          }
          that.map.setZoomAndCenter(curZoom, e.lnglat);
        });

        context.marker.on('mouseover', function (e) {
          console.log("======mouseover======")
          console.log(e)
          if (context.clusterData && context.clusterData.length) {
            let curData = context.clusterData[0].data
            let curAll = 0
            if (curData.hasOwnProperty('list') && curData.list.length) {
              curData.list.forEach(item => {
                curAll += item.count
              })
            }

            var info = [];
            info.push("<div class=\"map-info-box\">")
            info.push("<div class=\"map-info-title\"><div class=\"map-info-label\">" + curData.name + "</div>")
            info.push("<div class=\"map-info-value\">" + curAll + "</div></div>")
            if (curData.hasOwnProperty('list') && curData.list.length) {
              curData.list.forEach(item => {
                info.push("<div class=\"map-info-item\"><div class=\"map-info-label\">" + item.name + "</div>")
                info.push("<div class=\"map-info-value\">" + item.count + "</div></div>")
              })
              info.push("</div>")
            }

            infoWindow.setContent(info.join(""))
            infoWindow.open(that.map, context.marker.getPosition());
          }
        });

        context.marker.on('mouseout', function (e) {
          infoWindow.close()
        });
      };

      that.map.plugin(["AMap.MarkerCluster"], function () {
        that.MarkerCluster = new AMap.MarkerCluster(that.map, that.infoList, {
          renderClusterMarker: _renderClusterMarker,
          gridSize: 60
        });
        // that.map.setFitView()
      });
    },
    // async amapRequest(url, params) {
    //   return new Promise((resolve, reject) => {
    //     http.get(url, {
    //       params,
    //     }).then(res => {
    //       resolve(res.data)
    //     }).catch((err) => {
    //       reject(err)
    //     })
    //   })
    // },
  },
};
</script>
<style>
#container {
  width: 100%;
  height: 100%;
}

.map-info-box {
  color: white;
  width: auto;
  padding: .7rem;
  border-radius: .25rem;
  background-color: rgba(0, 0, 0, 0.7);
  border-width: 0;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
  text-align: center;
  font-size: 0.7rem;
}

.map-info-title {
  display: flex;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.map-info-item {
  display: flex;
  margin-bottom: 3px;
  font-size: 14px;
}

.map-info-label {
  width: auto;
  margin-right: 10px;
}

.map-info-value {
  width: auto;
}
</style>

<style>
.circleBox {

}

/* 扩散动画 */
.circle, .circle1, .circle2, .circle3 {
  width: 7px;
  height: 7px;
  background: rgba(255, 001, 002, 0.75);
  border: 1px solid rgba(255, 001, 002, 0.85);
  /*background: rgba(0, 153, 153, 0.75);*/
  /*border: 1px solid rgba(0, 153, 152, 0.85);*/
  border-radius: 50%;
  position: absolute;
}

.circle1, .circle2, .circle3 {
  /* animation: circleChange 2s 1s ease-out infinite; */
  animation-name: circleChange;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.circle1 {
  animation-delay: 1s;
}

.circle2 {
  animation-delay: 2s;
}

.circle3 {
  animation-delay: 3s;
}

@keyframes circleChange {
  0% {
    transform: scale(1);
    opacity: 0.95;
  }
  25% {
    transform: scale(2);
    opacity: 0.75;
  }
  50% {
    transform: scale(3);
    opacity: 0.5;
  }
  75% {
    transform: scale(4);
    opacity: 0.25;
  }
  100% {
    transform: scale(5);
    opacity: 0.05;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/amap/index.vue